import { useEffect, useState } from "react";
import addicon from '../images/additem.png';
import img1 from '../images/virtual.png';
import axios from "axios";
import deleteIcon from '../images/deleteicon.png';
import editIcon from '../images/editicon.png';
import viewIcon from '../images/viewicon.png';
import sortIcon from '../images/arrow.png';
import loadIcon from  '../images/loader2.webp';
import disableIcon from '../images/disableicon.png';
import { data } from "react-router";
import CustomerDiv from "../common/customerdiv";
const VirtualClients=()=>
{
const [show,setShow]=useState(false);
    const [invoicedata,setInvoiceData]=useState([]);
    const [dataToDisplay,setDataToDisplay]=useState([]);
    const [pageData,setPageData]=useState([]);    
    const [sortOrder,setsortOrder]=useState(1);
    const [page,setPage]=useState(1);
    const [pageSize,setPageSize]=useState(15);
    const [totalPage,setTotalPage]=useState(0);
    const [facilities,setFacilities]=useState([]);    
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
                baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization':'Bearer '+localStorage.getItem("token")
                }
            });  
    const columns = [       
        { name: "Facility", key: "facility", sortable: true},
        { name: "Name", key: "name", sortable: true },        
        { name: "Company", key: "company", sortable: true },       
        { name: "Address", key: "address", sortable: false },        
        { name: "State", key: "state", sortable: true },
        { name: "City", key: "city", sortable: true },
        { name: "Mobile", key: "mobile", sortable: true},      
        { name: "Email", key: "email", sortable: true},
        { name: "GSTIN", key: "gstin", sortable: true},
        
    ];
    
    async function loadInvoiceData()
    {
        //console.log("Token:",localStorage.getItem("token"));
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Virtual/GetAllVirtualCustomers").then(res=>
        {
            if(res.status==200)
            {
                setInvoiceData(res.data.data);
                setDataToDisplay(res.data.data);
                setPageData(res.data.data.slice(0,pageSize));
                setTotalPage(Math.ceil(res.data.data.length/pageSize));                  
            }
        });
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Facilities/GetAll").then(res=>
        {
            if(res.status==200)
            {
                setFacilities(res.data.data);                
            }
        });     
        setProgress(false);   
    }
    function searchData(event)
    {
        if(event.target.id=="searchText")
        {
            if(event.target.value.length>3)
            {
                let searchResult=invoicedata.filter((e)=>e.facility.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.name.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.address.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.state.toLowerCase().indexOf(event.target.value.toLowerCase())>=0  || e.city.toLowerCase().indexOf(event.target.value.toLowerCase())>=0 || e.mobile.toLowerCase().indexOf(event.target.value.toLowerCase())>=0|| e.email.toLowerCase().indexOf(event.target.value.toLowerCase())>=0|| e.gstin.toLowerCase().indexOf(event.target.value.toLowerCase())>=0);
                setDataToDisplay(searchResult);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay(invoicedata);                
                setPageData(invoicedata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchFacility")
        {
            if(event.target.value!="Facility")
            {
                let searchResult=invoicedata.filter((e)=>e.currentfacility==event.target.value);
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...invoicedata]);
                setPageData(invoicedata.slice(0,pageSize));
            }
            setPage(1);
        }
        if(event.target.id=="searchPlan")
        {
            if(event.target.value!="Plan")
            {
                let searchResult=invoicedata.filter((e)=>e.currentplan==event.target.value);   
                setDataToDisplay([...searchResult]);
                setPageData(searchResult.slice(0,pageSize));
            }
            else
            {
                setDataToDisplay([...invoicedata]);
                setPageData(invoicedata.slice(0,pageSize));
            }
            setPage(1);
        }            
    }    
    function sortData(colname)
    {
        
            let arr=[...dataToDisplay];
            arr.sort((e1,e2)=>
            {
                let x=e1[colname].trim().toLowerCase()>e2[colname].trim().toLowerCase()?1:-1;
                x=x*sortOrder;
                setsortOrder(sortOrder*-1);
                return x;
            }
            );                                    
            setDataToDisplay(arr);                        
            setPageData(arr.slice(0,pageSize));
            setPage(1);
        
             
    }
    function showPage(pagenumber)
    {
        let adata=dataToDisplay.slice((pagenumber-1)*pageSize,(pagenumber)*pageSize);
        setPageData(adata);
        setPage(pagenumber);
    }
    function showPrev(event)
    {
        let p=page;
        if(page>1) p--;        
        showPage(p);
    }
    function showNext(event)
    {
        let p=page;
        if(page<totalPage) p++;        
        showPage(p);
    }
    useEffect(()=>{
        loadInvoiceData();        
    },[]);
    return(
        <div>
            <div className="p-2 d-flex">
                <div className="me-2"><input type="text" id="searchText" style={{fontSize:'12px'}} onChange={searchData} placeholder="Search" className="form-control form-control-sm" /></div>
                <div className="me-2">
                    <select className="form-control form-control-sm" id="searchFacility" onChange={searchData} style={{fontSize:'12px'}}>
                        <option value="none">Select Facility</option>
                        {facilities.map((e, idx) => <option key={`fac-${idx}`} value={e.facilityname}>{e.facilityname}</option>)}
                    </select>
                </div>                
            </div>
            <div style={{borderRadius:'5px 5px 0px 0px',backgroundColor:'#ffccdd',padding:'5px',fontWeight:'bold'}}>Virtual Office Clients</div>            
            <div style={{overflow:"auto",fontSize:'12px'}}>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr className="table-primary">
                            <th>S.No.</th>
                            {columns.map((e,i)=>                            
                                <th key={i}>{e.name} {e.sortable?(<img src={sortIcon} onClick={()=>{sortData(e.key)}} style={{width:'10px',cursor:'pointer'}}  alt=""/>):(<></>)}</th>                            
                            )}                                                    
                        </tr>
                    </thead>
                    <tbody>
                        {pageData.map((e,i)=>
                            <tr key={i}>
                                <td>{(page-1)*pageSize+i+1}</td>
                                {columns.map((ee,ii)=>
                                    <td>{e[ee.key]}</td>                                    
                                )}                                
                            </tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="table-primary">
                            <th colSpan="2"><input type="button" onClick={showPrev} value="<<<" className="btn btn-success btn-sm" /></th>
                            <th colSpan="6" className="text-center"></th>
                            <th colSpan="2" className="text-end"><input type="button" value=">>>" onClick={showNext} className="btn btn-success btn-sm" /></th>
                        </tr>
                        <tr className="table-primary">
                            <th colSpan="10">Total {dataToDisplay.length} Entries</th>                        
                        </tr>
                    </tfoot>
                </table>
            </div>                                       
                {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default VirtualClients;